import { MessageCircle } from "lucide-react";
import { rodape, nav, contato, marca, whatsappLink, emailValido } from "@/content";
import { Logo } from "./Header";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 py-16">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 md:grid-cols-3 lg:px-8">
      <div>
        <Logo imgClass="h-10 w-auto" />
        <p className="mt-4 max-w-xs text-sm leading-6 text-slate-300">{rodape.descricao}</p>
      </div>
      <nav className="flex flex-col gap-3">
        {nav.links.map((l) => (
          <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`}
            className="text-sm text-slate-300 transition-colors duration-200 hover:text-cyan-300">{l.label}</a>
        ))}
      </nav>
      <div className="space-y-3 text-sm text-slate-300">
        <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
          className="flex items-center gap-2 transition-colors duration-200 hover:text-cyan-300">
          <MessageCircle size={16} /> WhatsApp {contato.telefoneExibicao}
        </a>
        {emailValido ? (
          <a href={`mailto:${contato.email}`} data-testid="footer-email"
            className="block transition-colors duration-200 hover:text-cyan-300">{contato.email}</a>
        ) : (
          <p data-testid="footer-email">{contato.email}</p>
        )}
        <p data-testid="footer-city">{contato.endereco}<br />{contato.cidade} · Online para todo o Brasil</p>
      </div>
    </div>
    <p className="mx-auto mt-12 max-w-7xl px-6 text-xs text-slate-500 lg:px-8">
      © {new Date().getFullYear()} {marca.nome} {marca.complemento}. {rodape.direitos}
    </p>
  </footer>
);

export const WhatsAppFloat = () => (
  <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" aria-label="Fale conosco no WhatsApp"
    data-testid="whatsapp-float-btn"
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 sm:bottom-6 sm:right-6 items-center justify-center rounded-full bg-gradient-to-br from-cyan-300 to-blue-500 text-[#030712] shadow-[0_0_30px_rgba(34,211,238,0.5)] transition-transform duration-300 hover:scale-110">
    <span className="absolute inset-0 animate-ping rounded-full bg-cyan-300/30" />
    <MessageCircle size={26} className="relative" />
  </a>
);
